import api from "./axios";

export const getDispatches = () =>
  api.get("/dispatch");

export const createDispatch = (data) =>
  api.post("/dispatch", data);

export const getSalesOrderDispatch = (id) =>
  api.get(`/dispatch/sales-order/${id}`);

export const createDispatchFromSO = (data) =>
  api.post("/dispatch/sales-order", data);